import { createTRPCProxyClient, httpBatchLink } from '@trpc/client';
import type { AppRouter } from '../../../portal-api/src/trpc/router';

/**
 * Get the API URL from environment or default to localhost
 */
const getApiUrl = () => {
  const apiUrl = import.meta.env.VITE_API_URL;
  if (apiUrl) return apiUrl;
  return '';
};

/**
 * Token getter function - will be set by ClerkTokenProvider
 */
let tokenGetter: (() => Promise<string | null>) | null = null;

/**
 * Set the token getter function (called from ClerkTokenProvider)
 */
export const setTokenGetter = (getter: () => Promise<string | null>): void => {
  tokenGetter = getter;
};

/**
 * tRPC client instance with Clerk authentication
 */
export const trpc = createTRPCProxyClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${getApiUrl()}/trpc`,
      async headers() {
        if (tokenGetter) {
          const token = await tokenGetter();
          if (token) {
            return { Authorization: `Bearer ${token}` };
          }
        }
        return {};
      },
    }),
  ],
});

/**
 * Export types for use in components
 */
export type { AppRouter };
